import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Upload, FileUp, Users } from 'lucide-react';

const Tools = () => {
  const navigate = useNavigate();

  const toolSections = [
    {
      icon: FileUp,
      title: 'Import Data',
      description: 'Import students, classes, and other data from CSV files',
      action: () => navigate('/settings/tools/import'),
      iconBg: 'bg-blue-100 dark:bg-blue-900/30',
      iconColor: 'text-blue-600 dark:text-blue-400'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-4">
        <div className="flex items-center space-x-3">
          <button
            onClick={() => navigate('/settings')}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-5 h-5 text-gray-600 dark:text-gray-400" />
          </button>
          <Upload className="w-8 h-8 text-[#7A99D8]" />
          <div>
            <h1 className="text-lg font-bold text-[#3C3C3C] dark:text-gray-200">Tools</h1>
            <p className="text-sm text-gray-600 dark:text-gray-400">Utilities and data management tools</p>
          </div>
        </div>
      </div>

      <div className="px-6 py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {toolSections.map((section) => {
            const Icon = section.icon;
            return (
              <button
                key={section.title}
                onClick={section.action}
                className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 hover:border-[#7A99D8] dark:hover:border-[#7A99D8] transition-colors text-left group"
              >
                <div className="flex items-start space-x-4">
                  <div className={`p-3 ${section.iconBg} rounded-lg`}>
                    <Icon className={`w-6 h-6 ${section.iconColor}`} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white group-hover:text-[#7A99D8] transition-colors">
                      {section.title}
                    </h3>
                    <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
                      {section.description}
                    </p>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Tools;
